import React, { useState, useEffect } from "react";
import "./GroupingImages.scss";
import MediaViewer from './MediaViewer';

const GroupingImages = ({ arr,orientation }) => {
  const [isOpen, setOpen] = useState(false);
  const [indexA, setIndex] = useState("");
  const [multimedia, setMultimedia] = useState(undefined);
  
  useEffect(() => {
		if(arr.length > 0){
			let arry = arr.map(file => ({
				url: file,
				mediaType: 'image',
			}))
			setMultimedia(arry);
		}
	}, [arr]);

  return (
    <div className={"uin-group-imagen"}>
      {arr.length <= 2 ? (
        arr.map((image, i) => (
          <div className={"box-one " + (arr.length > 1 ? "contain" : "")}>
            <img
              key={i}
              src={image}
              alt="imagen"
              onClick={() => {
                setOpen(true);
                setIndex(i);
              }}
            />
          </div>
        ))
      ) : arr.length === 3 ? (
        <>
          <div className={"box-one"}>
            <img
              src={arr[0]}
              alt="imagen"
              onClick={() => {
                setOpen(true);
                setIndex(0);
              }}
            />
          </div>
          <div className={"box-two " + (arr.length > 2 ? "contain" : "")}>
            <div className={"box-one"}>
              <img
                src={arr[1]}
                alt="imagen"
                onClick={() => {
                  setOpen(true);
                  setIndex(1);
                }}
              />
            </div>
            <div className={"box-one"}>
              <img
                src={arr[2]}
                alt="imagen"
                onClick={() => {
                  setOpen(true);
                  setIndex(2);
                }}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={"box-two " + (arr.length > 2 ? "contain" : "")}>
            <div className={"box-one"}>
              <img
                src={arr[0]}
                alt="imagen"
                onClick={() => {
                  setOpen(true);
                  setIndex(0);
                }}
              />
            </div>
            <div className={"box-one"}>
              <img
                src={arr[1]}
                alt="imagen"
                onClick={() => {
                  setOpen(true);
                  setIndex(1);
                }}
              />
            </div>
          </div>
          <div className={"box-two " + (arr.length > 2 ? "contain" : "")}>
            <div className={"box-one"}>
              <img
                src={arr[2]}
                alt="imagen"
                onClick={() => {
                  setOpen(true);
                  setIndex(2);
                }}
              />
            </div>
            <div className={"box-one"}>
              <img
                src={arr[3]}
                alt="imagen"
                onClick={() => {
                  setOpen(true);
                  setIndex(3);
                }}
              />
            </div>
          </div>
        </>
      )}
      <MediaViewer show={isOpen} toggle={() => setOpen(o => !o)} multimediaFiles={multimedia ? multimedia : false} index={indexA} withFooter={true} orientation={orientation}/>
    </div>
  );
};

export default GroupingImages;
